import { put, call, takeLatest, select, take, race, actionChannel, spawn } from "redux-saga/effects";
import { delay, buffers } from "redux-saga";
import { WS_MESSAGE } from '../../../common/actions/websocketActions';
import { liveActivitySelected } from '../../../common/slice/liveUpdates';
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import { SHOW_LOADER, HIDE_LOADER, SHOW_TOAST_WITH_PROPS} from '../../../common/actionConstants';
import { HIDE_DIALOGUE_BOX } from '../../../components/DialogueBox/actionConstants'
import {CHANGE_ACTIVITY_REASSIGN_REQUEST, CHANGE_ACTIVITY_REASSIGN_ERROR } from '../../../components/ChangeAssignee/actionConstants';
import * as WorkkardErrorConstant from '../errorConstant';
import { ErrorCode, StringConstants,RightPanelConstant } from '../constants';
import { logout } from './common';
import {  updateActivityListingData, getActivityDetail } from '../Saga/leftPanelContainer';
import { updatePanelDataPermissionSet } from '../Saga/middlePanelContainer';
import { BUTTON_LOADER } from "../actions/actionConstants";
import  *  as  PUBLIC_API_ACTIVITY_ACTION from "../../../publicApiActions/activityActions";
import {getAxiosError } from '../../../common/util';
import {
  normalizeAssociatedWorkkardResponse,
  normalizeAssociatedWorkkardFilterResponse,
  normalizeContactInsuredResponse,
} from '../../../services/workkardDetail';
import {
  fetchAssociatedWorkkardRequest,
  fetchAssociatedWorkkardSuccess,
  fetchAssociatedWorkkardError,
  clearAssociatedWorkkardData,
  fetchAssociatedWorkkardFilterRequest,
  fetchAssociatedWorkkardFilterSuccess,
  fetchAssociatedWorkkardFilterError,
  fetchContactInsuredRequest,
  fetchContactInsuredSuccess,
  saveContactInsuredRequest,
  contactInsuredResponseError,
  saveMessageQueue,
} from '../slice';

export function* getAssociatedWorkkardData({ payload }) {
  try {
    yield put({ type: SHOW_LOADER });
    const Data   = yield call(Api.getAssociatedWorkkardList, payload.wkId, payload.tmplType, payload.selectedFilter ,payload.row,payload.skip,payload.take,payload.orgids)
    if (Data.status == 200) {
      if(payload.clearAssociatedWorkkard){
        yield put(clearAssociatedWorkkardData());
      }
      const normalizedData = normalizeAssociatedWorkkardResponse(Data, payload);
      const associatedwkdata = Object.assign({}, payload, normalizedData)
      yield put(fetchAssociatedWorkkardSuccess(associatedwkdata));
    } else if(Data.status ==ErrorCode.RedirectToLogout){
      yield* logout();
    } else {
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status:Data.status, isErrorScreen:false  }
      });
      yield put(fetchAssociatedWorkkardError({errorMessage: WorkkardErrorConstant.FETCH_ASSOCIATED_WARKKARD_DATA_ERROR[Data.status]}));
    }
  }
  catch (error) {
    yield put(fetchAssociatedWorkkardError({errorMessage: error}));
  }
  finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* getWorkkardFollowersList({ payload }) {
  try {
    const { wkFollowers } = yield call(Api.getWorkkardWatcherList, payload.cId, payload.sponsorId)
    if (wkFollowers) {
      yield put({
        type: ActionConstants.WORKKARD_WATCHER_LIST,
        payload: wkFollowers
      });
    }
  }
  catch (error) {

  }
  finally {

  }
}

export function* fetchFilter({ payload }) {
  try{
    const associatedWorkkardFilters = yield call(Api.fetchFilters, payload.templateType, payload.wkId, payload.selectedFilter);
    if(associatedWorkkardFilters && associatedWorkkardFilters.status === 200) {
      yield put(fetchAssociatedWorkkardFilterSuccess(normalizeAssociatedWorkkardFilterResponse(associatedWorkkardFilters)));
    } else {
      yield put({
        type: ActionConstants.LOG_APPLICATON_ERROR,
        payload: { status:associatedWorkkardFilters.status, isErrorScreen:false  }
      });
      yield put(fetchAssociatedWorkkardFilterError({errorMessage: WorkkardErrorConstant.FETCH_ASSOCIATED_WARKKARD_FILTER_ERROR[associatedWorkkardFilters.status]}));
    }
  }
  catch(error){
    yield put(fetchAssociatedWorkkardFilterError({errorMessage: error}));
  }
  finally {

  }
}

export function* getActivityFollowersList({ payload }) {
    try {
      const { actFollowers } = yield call(Api.getActivityWatcherList, payload.actId)
      if (actFollowers) {
        yield put({
          type: ActionConstants.ACTIVITY_WATCHER_LIST,
          payload: actFollowers
        });
      }
    }
    catch (error) {
  
    }
    finally {
  
    }
}

export function* fetchContactInsuredDetails({payload}) {
  try{
    yield put({ type: SHOW_LOADER });
      const contactInsureDetails = yield call(Api.fetchContactInsuredDetails, payload);
      if(contactInsureDetails.status == 200){
          yield put(fetchContactInsuredSuccess(normalizeContactInsuredResponse(contactInsureDetails.contactInsuredModel)));
      }
      else if(contactInsureDetails.status ==  ErrorCode.RedirectToLogout){
          yield* logout();
      } else {
          yield put({
          type: LOG_APPLICATON_ERROR,
          payload: { status:contactInsureDetails.status, isErrorScreen:false  }
          });
      }
  }
  catch(error){

  }
  finally{
      yield put({ type: HIDE_LOADER });
  }
}

export function* saveContactInsuredDetails({payload}){
  try{
      yield put({ type: BUTTON_LOADER, payload: { contactInsured: true}});
      yield put(contactInsuredResponseError({}));
      const response = yield call(Api.saveContactInsuredDetails, ActionConstants.SAVE_CONTACT_INSURED_DETAILS, payload);
      if(response.status == 200){
        const {Data} = response;
        yield put({ type: HIDE_DIALOGUE_BOX });
        const getView = (state) => state.workkardDetail.panelVisibility.toggleView;
        const getWorkkardDetailData = (state) => state.workkardDetail.workkardDetail;
        const getActDetailData = (state) => state.workkardDetail.activityDetail;
        const getItems = (state) => state.workkardDetail.middlePanel;
        const middlePanel = yield select(getItems);
        const toggleView = yield select(getView);
        const workkardDetailData = yield select(getWorkkardDetailData);
        const actDetailData = yield select(getActDetailData);
        if(Data.msgStatus != "failed"){
          if(Data.sendVia=="text")
          {
            yield put(saveMessageQueue({Id:Data.draftNoteId,sendVia:Data.sendVia, type:"push"}));
          }

          if (middlePanel.activeTab == 0 && Data.sendVia == "email") {
            const param = {
              type: middlePanel.notes.type == StringConstants.activity ? StringConstants.activity : StringConstants.workkard,
              actId: (middlePanel.notes.type == StringConstants.activity && actDetailData.ActivityId) ? actDetailData.ActivityId : 0,
              cId: workkardDetailData.WorkkardId,
              skip: 0,
              take: middlePanel.notes.skip + middlePanel.notes.take || 10,
              sortBy: (middlePanel.notes.type == StringConstants.activity) ? "0" : "1",
              reviewFilter: "0"
            }
            if ((middlePanel.notes.type == StringConstants.activity && actDetailData.ActivityId === Data.activityId) || 
               (middlePanel.notes.type == StringConstants.workkard && Data.activityId == null)) {
              yield* updatePanelDataPermissionSet({ payload: param, permission: { isUpdateNotes: true } })
            } 
          }
        }
        else{
          if (middlePanel.activeTab == 0) {
            const param = {
              type: middlePanel.notes.type == StringConstants.activity ? StringConstants.activity : StringConstants.workkard,
              actId: (middlePanel.notes.type == StringConstants.activity && actDetailData.ActivityId) ? actDetailData.ActivityId : 0,
              cId: workkardDetailData.WorkkardId,
              skip: 0,
              take: middlePanel.notes.skip + middlePanel.notes.take || 10,
              sortBy: (middlePanel.notes.type == StringConstants.activity) ? "0" : "1",
              reviewFilter:  "0"
            }
            if (middlePanel.notes.type == StringConstants.activity && actDetailData.ActivityId === Data.activityId ||
               (middlePanel.notes.type == StringConstants.workkard && Data.activityId == null)) {
              yield* updatePanelDataPermissionSet({ payload: param, permission: { isUpdateNotes: true } })
            } 
          }
          if(Data.sendVia != "email"){
           if(toggleView != RightPanelConstant.NormalView || middlePanel.activeTab!=0 || Data.noteType != middlePanel.notes.type || (Data.activityId!=null && Data.activityId != actDetailData.ActivityId))
           {
            const toastPayload={
              message:"Contact Insured action failed. Please refer Notes for details.",
              iconType:"warning",
              delayTime:5000,
              entityType: Data.noteType,
              cId: workkardDetailData.WorkkardId,
              actId: Data.noteType == StringConstants.activity ? Data.activityId : 0,
              showActions: true,
              autoClose:true
            }
            yield put({type:SHOW_TOAST_WITH_PROPS,payload:toastPayload})
          }
        }
      }
      }
      else if(response.status ==  ErrorCode.RedirectToLogout){
          yield* logout();
      } else {
        let errors = response.error;
          yield put({ type: BUTTON_LOADER, payload: { contactInsured: false}});
          yield put(contactInsuredResponseError(errors));
      }
  }
  catch(error){
  }
  finally{
      yield put({ type: BUTTON_LOADER, payload: { contactInsured: false}});
  }
}
const REASSIGN_PROJECTION_SOCKET_TIMEOUT_MS = 5000;

const sameId = (a, b) => a != null && b != null && String(a) === String(b);

function* takeMatchingReassign(channel, activityId) {
  while (true) {
    const { payload } = yield take(channel);
    if (payload?.event !== 'activity.reassigned') continue;
    if (!sameId(payload?.entity?.activityId, activityId)) continue;
    return true;
  }
}

function* awaitReassignProjection(channel, activityId) {
  const { seen } = yield race({
    seen: call(takeMatchingReassign, channel, activityId),
    timeout: call(delay, REASSIGN_PROJECTION_SOCKET_TIMEOUT_MS),
  });
  return Boolean(seen);
}

// Only bounds how long an unanswered handover keeps its channel open; nothing
// waits on it.
const HANDOVER_SOCKET_TIMEOUT_MS = 60000;

// Switches to the activity a reassignment handed the work over to, once its
// frame says it is readable -- but only if the user is still on the activity
// the reassignment was made from. Owns `channel` and closes it.
function* switchToHandoverActivity(channel, { workkardId, fromActivityId, toActivityId }) {
  try {
    const { seen } = yield race({
      seen: call(takeMatchingReassign, channel, toActivityId),
      timeout: call(delay, HANDOVER_SOCKET_TIMEOUT_MS),
    });
    if (!seen) return;
    const { claimId, currentActivity } = yield select((state) => ({
      claimId: state.workkardDetail.workkardDetail.Id,
      currentActivity: state.workkardDetail.activityListing.currentActivity,
    }));
    if (!sameId(claimId, workkardId) || !sameId(currentActivity, fromActivityId)) return;
    yield put(liveActivitySelected({ workkardId, activityId: toActivityId }));
  } finally {
    channel.close();
  }
}

export function* postActivityReassigne({payload}){
  // Sliding, not the default fixed buffer, which throws on overflow: only the
  // frames around the response matter, older ones can be dropped.
  const wsChannel = yield actionChannel(WS_MESSAGE, buffers.sliding(50));
  // A handover passes the channel to its watcher, which outlives this saga.
  let channelHandedOff = false;
  try {
    yield put({ type: BUTTON_LOADER, payload: { activityAssignee: true}});
    yield put({ type: SHOW_LOADER });
    const response = yield call(PUBLIC_API_ACTIVITY_ACTION.changeActivityAssignee, {...payload});
    if(response?.errors){
      yield put({ type: HIDE_LOADER });
      if(response.status == ErrorCode.RedirectToLogout){
        //yield* logout();
      }
      // @TODO need to  remove
      else {
        yield put({ type: HIDE_LOADER });      
        yield put({
          type: ActionConstants.LOG_APPLICATON_ERROR,
          payload: { status:response.status, isErrorScreen:false  }
        });
        const errorMessage = response.ValidationMsg ? response.ValidationMsg : REASSIGN_ACTIVITY_ERROR_VALIDATION_MESSAGE[response.status];
        yield put({type : CHANGE_ACTIVITY_REASSIGN_ERROR, payload : {errorData: errorMessage } })
      }
    }else{
      const payloadData = {
        payload: {
          actId: response.activity_id != null ? response.activity_id : payload.activityId
        }
      }
      const newActivityId = payloadData.payload.actId;
      const isHandover = !sameId(newActivityId, payload.activityId);

      // Forced refetches below: the listing row the detail would otherwise be
      // read from is stale.
      if (isHandover) {
        // The new activity may not be readable yet, so it is not waited for
        // here: the watcher switches to it when its frame arrives. Meanwhile the
        // activity still on screen is refreshed to show it was handed over.
        yield spawn(switchToHandoverActivity, wsChannel, {
          workkardId: payload.workkardId,
          fromActivityId: payload.activityId,
          toActivityId: newActivityId,
        });
        channelHandedOff = true;
        yield* getActivityDetail({ payload: { actId: payload.activityId, force: true } });
      } else {
        // Refetching on the HTTP ack reads the pre-reassignment status and
        // menu, so wait for this activity's frame first.
        yield call(awaitReassignProjection, wsChannel, newActivityId);
        yield* getActivityDetail({ payload: { actId: newActivityId, force: true } });
      }
      yield* updateActivityListingData({ cId: payload.workkardId });
      
      const toggleCombinedView=(state)=>state.workkardDetail.panelVisibility;
      const isCombinedView=yield select(toggleCombinedView);

      const getWorkkardDetailData=(state)=>state.workkardDetail;
      const workkardDetailData=yield select(getWorkkardDetailData);

      if (workkardDetailData.middlePanel.activeTab == 0 && response.activity_id == payload.activityId){
        const notesPayload = {
          type: workkardDetailData.middlePanel.notes.type,
          cId: payload.workkardId,
          actId: payload.activityId,
          skip: 0,
          take: 10,
          sortBy: "0",
          reviewFilter: workkardDetailData.middlePanel.notes.reviewFilter,
        }
        yield* updatePanelDataPermissionSet({ payload: notesPayload, permission: { isUpdateNotes: true } })
      }

      if (isCombinedView.toggleView==RightPanelConstant.CombinedViewText){
        const combinedViewPayload = {
            id: workkardDetailData.workkardDetail.Id,
            start:workkardDetailData.combinedView.start,
            end : workkardDetailData.combinedView.end,
        }
        yield put({type: ActionConstants.RESET_ALL_COMBINED_VIEW_DATA})
        yield* updatePanelDataPermissionSet({ payload: combinedViewPayload , permission:{isUpdateCombinedView:true}})
      }

      else if(response.activity_id == payload.activityId){
        const middlePanel = workkardDetailData.middlePanel;
        const {diaries, logs} = middlePanel;

        switch(middlePanel.activeTab){
          case 1: {
            if (payload.attachments.length > 0) {
              const filesPayload={
                type: StringConstants.activity,
                cId: payload.workkardId,
                actId: payloadData.payload.actId,
                skip: 0,
                take: 100,
                sortBy: "0",
                largeView: false,
                isSelectAll: false,
                filterOption:  JSON.stringify(["Document","Photo","Audio","Video","Email","Other","activity"])
              }
              yield* updatePanelDataPermissionSet({ payload: filesPayload , permission:{isUpdateFiles:true}})
            }
            break;
          }
          case 2: {
            yield put({ type: ActionConstants.RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS });
            const diaryPayload = {
                cId: payload.workkardId,
                type: diaries.type,
                actId: payload.activityId,
                skip: 0,
                take: 10,
                sortBy: diaries.sortBy || "SortByDueDate",
                sort: diaries.filter.sort || "OPEN",
                rows: 10,
                todoOwners: diaries.filter.todoOwners,
                filterOption:JSON.stringify(Object.assign([], diaries.filter.filterOption, ["activity", "workkard"]))
            }
            yield put ({type: ActionConstants.WORKKARD_TODO_OWNERS_REQUEST, payload:diaryPayload})
            break;
          }
          case 3: {
            if(logs.type==StringConstants.activity){
              const logsPayload = {
                type: StringConstants.activity,
                cId: payload.workkardId,
                actId: payloadData.payload.actId,
                skip: 0,
                take: 10
              }
              yield* updatePanelDataPermissionSet({ payload: logsPayload , permission:{isUpdateLogs:true}})
            }
            break;
          }
        }
      }
    }
    yield put({ type: HIDE_LOADER });
  } catch (error) {
    let axiosError =  getAxiosError(error);
    if(axiosError.status ==  ErrorCode.Fail)
    {
      yield put({ type: CHANGE_ACTIVITY_REASSIGN_ERROR, payload: {errorData: axiosError.error } });
    }
  }
  finally{
    if (!channelHandedOff) wsChannel.close();
    yield put({ type: BUTTON_LOADER, payload: { activityAssignee: false}});
    yield put({ type: HIDE_LOADER });
    yield put({ type: HIDE_DIALOGUE_BOX });
  }
}



export default [
  takeLatest(fetchAssociatedWorkkardRequest.type, getAssociatedWorkkardData),
  takeLatest(fetchAssociatedWorkkardFilterRequest.type, fetchFilter),
  takeLatest(CHANGE_ACTIVITY_REASSIGN_REQUEST,postActivityReassigne),
  takeLatest(fetchContactInsuredRequest.type,fetchContactInsuredDetails),
  takeLatest(saveContactInsuredRequest.type,saveContactInsuredDetails),

];
  